const ENRiskMatrix = {
	"Ameaças": "Threats",
	"Classificação de riscos": "Risks classification",
	"Oportunidades": "Opportunities",
	"Matriz de Riscos": "Risk Matrix",
	"Matriz de riscos": "Risk matrix"
};

export default ENRiskMatrix;
